let Status = {
  PD: {code: 'PD', name: 'Pendente'},
	RQ: {code: 'RQ', name: 'Em solicitação'},
	KK: {code: 'KK', name: 'Confirmado'},
	XL: {code: 'XL', name: 'Cancelado'}
};

export default Status;
export const status = Object.keys(Status).map(key => Status[key]);



// WEBPACK FOOTER //
// ./src/enums/Status.js